(function(){
  var KEY='np_sum25_seen_v1';
  var DELAY=6000;
  var CONTACT_EMAIL='kamila@noirprive.us';
  function syncContactEmail(){
    document.querySelectorAll('a[href="mailto:hello@noirprive.us"]').forEach(function(a){
      a.setAttribute('href','mailto:'+CONTACT_EMAIL);
      if((a.textContent||'').trim().toLowerCase()==='hello@noirprive.us') a.textContent=CONTACT_EMAIL;
    });
  }
  // Dev override: ?popup=1 or ?discount=1 forces the discount notice to re-fire.
  try{if(/[?&](popup|discount)=1/.test(location.search)) sessionStorage.removeItem(KEY);}catch(e){}
  function show(){
    var el=document.getElementById('npPop');
    if(!el) return;
    if(document.body.classList.contains('cd-open')||document.body.classList.contains('sz-open')||document.body.classList.contains('ag-open')){
      setTimeout(show,2000);
      return;
    }
    el.classList.add('show');
    el.setAttribute('aria-hidden','false');
    try{sessionStorage.setItem(KEY,'1');}catch(e){}
  }
  function close(){
    var el=document.getElementById('npPop');
    if(!el) return;
    el.classList.remove('show');
    el.setAttribute('aria-hidden','true');
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-np-close]')){
      close();
      // if it was an in-page anchor, let it scroll after close
    }
  });

  // smooth scroll for in-page anchors + close popup if open
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href^="#"]');
    if(!a) return;
    var href=a.getAttribute('href');
    if(!href||href==='#'||href.length<2) return;
    var id=href.slice(1);
    var t=document.getElementById(id);
    if(!t) return;
    e.preventDefault();
    var pop=document.getElementById('npPop');
    if(pop&&pop.classList.contains('show')){
      pop.classList.remove('show');
      pop.setAttribute('aria-hidden','true');
      setTimeout(function(){t.scrollIntoView({behavior:'smooth',block:'start'});},120);
    }else{
      t.scrollIntoView({behavior:'smooth',block:'start'});
    }
    history.replaceState(null,'','#'+id);
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape') close();
  });
  function init(){
    try{if(sessionStorage.getItem(KEY)) return;}catch(e){}
    setTimeout(show,DELAY);
  }
  function stickyInit(){
    if(document.querySelector('.sticky-buy')) document.body.classList.add('has-sticky-buy');
  }
  if(document.readyState!=='loading'){syncContactEmail();init();}
  else document.addEventListener('DOMContentLoaded',function(){syncContactEmail();init();});
  if(document.readyState!=='loading') stickyInit();
  else document.addEventListener('DOMContentLoaded',stickyInit);

  // --- scroll reveal ---
  function observe(){
    var nodes=document.querySelectorAll('.reveal');
    if(!nodes.length) return;
    if(!('IntersectionObserver' in window)){
      nodes.forEach(function(n){n.classList.add('in');});
      return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    },{threshold:0.12,rootMargin:'0px 0px -40px 0px'});
    nodes.forEach(function(n){io.observe(n);});
  }
  if(document.readyState!=='loading') observe();
  else document.addEventListener('DOMContentLoaded',observe);

  // ============ AJAX CART ============
  var CART_URL='/cart.js',ADD_URL='/cart/add.js',CHANGE_URL='/cart/change.js',CHECKOUT_URL='/checkout?discount=SUM25';
  var cartBusy=false;
  function fmtMoney(cents,currency){
    try{return new Intl.NumberFormat('en-US',{style:'currency',currency:currency||'USD'}).format((cents||0)/100);}
    catch(e){return '$'+((cents||0)/100).toFixed(2);}
  }
  function escapeHtml(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function drawer(){return document.getElementById('cartDrawer');}
  function body(){return document.querySelector('[data-cart-body]');}
  function foot(){return document.querySelector('[data-cart-foot]');}
  function sizePicker(){return document.getElementById('npSizePicker');}
  var PRICE_TEST_KEY='np_box_price_test_v1';
  var PRICE_TEST_ROUTES={
    control:'/products/noir-underware',
    low:'/products/noir-underware-ab-239',
    high:'/products/noir-underware-ab-375'
  };
  var PRICE_TEST_DISPLAY={
    control:'$299.00',
    low:'$189.39',
    high:'$339.00'
  };
  function priceTestAssignment(){
    try{
      var saved=localStorage.getItem(PRICE_TEST_KEY);
      if(saved==='control'||saved==='low'||saved==='high') return saved;
    }catch(e){}
    var r=Math.random();
    // 75% control, 20% low-price test, 5% high-price test.
    var assigned=r<0.75?'control':(r<0.95?'low':'high');
    try{localStorage.setItem(PRICE_TEST_KEY,assigned);}catch(e){}
    return assigned;
  }
  function attrForAssignment(base,assigned){
    return base+(assigned==='control'?'control':assigned);
  }
  function applyPriceTest(){
    var assigned=priceTestAssignment();
    document.documentElement.setAttribute('data-price-test',assigned);
    document.querySelectorAll('[data-ab-price]').forEach(function(el){
      var value=PRICE_TEST_DISPLAY[assigned]||el.getAttribute(attrForAssignment('data-price-',assigned));
      if(value) el.textContent=value;
    });
    document.querySelectorAll('[data-ab-size-option]').forEach(function(input){
      var variant=input.getAttribute(attrForAssignment('data-ab-variant-',assigned));
      var price=PRICE_TEST_DISPLAY[assigned]||input.getAttribute(attrForAssignment('data-ab-price-',assigned));
      var available=input.getAttribute(attrForAssignment('data-ab-available-',assigned))==='true';
      var option=input.closest('.sz-option');
      input.disabled=!variant||!available;
      if(!variant||!available) input.checked=false;
      if(variant) input.value=variant;
      if(option) option.classList.toggle('is-disabled',!variant||!available);
      var priceEl=input.closest('.sz-option')&&input.closest('.sz-option').querySelector('[data-ab-size-price]');
      if(priceEl&&price) priceEl.textContent=price+(available?'':' · sold out');
    });
    document.querySelectorAll('[data-price-test-property]').forEach(function(input){
      input.value=assigned==='control'?'control':(assigned==='low'?'239':'375');
    });
    document.querySelectorAll('[data-price-test-link]').forEach(function(a){
      if(PRICE_TEST_ROUTES[assigned]) a.setAttribute('href',PRICE_TEST_ROUTES[assigned]);
    });
    var path=location.pathname.replace(/\/$/,'');
    if(/^\/products\/noir-underware(?:-ab-(?:239|375))?$/.test(path)){
      var target=PRICE_TEST_ROUTES[assigned]||PRICE_TEST_ROUTES.control;
      if(path!==target){
        location.replace(target+location.search+location.hash);
      }
    }
    return assigned;
  }
  function setSizeOpen(open){
    var el=sizePicker();if(!el) return;
    el.classList.toggle('open',open);
    el.setAttribute('aria-hidden',open?'false':'true');
    document.body.classList.toggle('sz-open',open);
    if(open){
      var pop=document.getElementById('npPop');
      if(pop){pop.classList.remove('show');pop.setAttribute('aria-hidden','true');}
    }
  }
  function setCartBusy(busy){
    cartBusy=busy;
    document.body.classList.toggle('cart-busy',busy);
    document.querySelectorAll('.cd-checkout,.cp-checkout').forEach(function(el){
      if(busy){
        el.classList.add('is-busy');
        el.setAttribute('aria-disabled','true');
        el.setAttribute('tabindex','-1');
      }else{
        el.classList.remove('is-busy');
        el.removeAttribute('aria-disabled');
        el.removeAttribute('tabindex');
      }
    });
    document.querySelectorAll('.cd-qty-btn,.cd-rm,.cp-qty-btn,.cp-rm').forEach(function(el){
      el.disabled=!!busy;
    });
  }
  function syncPdpVariant(form){
    var vs=form.querySelector('[data-pdp-variant-select]');
    if(!vs) return true;
    var atc=form.querySelector('.pdp-atc');
    var selects=form.querySelectorAll('[data-pdp-option]');
    var chosen=[],complete=true,matched=null;
    selects.forEach(function(s){
      chosen.push(s.value);
      if(!s.value) complete=false;
    });
    while(chosen.length<3) chosen.push('');
    Array.prototype.forEach.call(vs.options,function(o){
      if(!o.value) return;
      var opts=(o.getAttribute('data-options')||'').split('|');
      if(opts[0]===chosen[0]&&opts[1]===chosen[1]&&opts[2]===chosen[2]) matched=o;
    });
    if(!complete||!matched||matched.disabled){
      vs.value='';
      if(atc){
        atc.disabled=true;
        atc.textContent=matched&&matched.disabled?(atc.getAttribute('data-soldout-text')||'Sold Out'):(atc.getAttribute('data-choose-text')||'Choose your size');
      }
      return false;
    }
    vs.value=matched.value;
    if(atc){
      atc.disabled=false;
      atc.textContent=atc.getAttribute('data-default-text')||'Add to cart';
    }
    return true;
  }
  function setOpen(open){
    var d=drawer();if(!d) return;
    d.classList.toggle('open',open);
    d.setAttribute('aria-hidden',open?'false':'true');
    document.body.classList.toggle('cd-open',open);
  }
  function updateBadges(count){
    // ensure every /cart icon has a badge, inject if missing
    document.querySelectorAll('a[href="/cart"],a[href^="/cart?"]').forEach(function(a){
      var b=a.querySelector('[data-cart-count]');
      if(!b){
        b=document.createElement('span');
        b.className='nav-cart-count';
        b.setAttribute('data-cart-count','');
        a.appendChild(b);
      }
      if(count>0){b.textContent=count;b.classList.add('has');}
      else{b.textContent='';b.classList.remove('has');}
    });
  }
  function renderDrawer(cart){
    var b=body(),f=foot();if(!b||!f) return;
    if(!cart||!cart.item_count){
      b.innerHTML='<p class="cd-empty">Your cart is empty.</p><a href="/#np-shop" class="cd-shop-link" data-cart-close>Shop the collection →</a>';
      f.innerHTML='';
      return;
    }
    var cur=cart.currency||'USD';
    b.innerHTML=cart.items.map(function(it){
      var variant=(it.variant_title&&it.variant_title!=='Default Title')?'<span class="cd-item-variant">Selected size: '+escapeHtml(it.variant_title)+'</span>':'';
      var img=it.image?'<img src="'+escapeHtml(it.image.replace(/(\.[a-z]+)$/,'_200x$1'))+'" alt="'+escapeHtml(it.product_title)+'" loading="lazy">':'';
      return '<article class="cd-item" data-key="'+escapeHtml(it.key)+'">'+
        '<a href="'+escapeHtml(it.url)+'" class="cd-item-img">'+img+'</a>'+
        '<div class="cd-item-info">'+
          '<a href="'+escapeHtml(it.url)+'" class="cd-item-title">'+escapeHtml(it.product_title)+'</a>'+
          variant+
          '<div class="cd-qty">'+
            '<button type="button" class="cd-qty-btn" data-cart-qty="'+escapeHtml(it.key)+'" data-delta="-1" aria-label="Decrease">−</button>'+
            '<span class="cd-qty-v">'+it.quantity+'</span>'+
            '<button type="button" class="cd-qty-btn" data-cart-qty="'+escapeHtml(it.key)+'" data-delta="1" aria-label="Increase">+</button>'+
            '<button type="button" class="cd-rm" data-cart-remove="'+escapeHtml(it.key)+'">Remove</button>'+
          '</div>'+
        '</div>'+
        '<span class="cd-item-price">'+fmtMoney(it.final_line_price,cur)+'</span>'+
      '</article>';
    }).join('');
    f.innerHTML=
      '<div class="cd-sub"><span class="cd-sub-l">Subtotal</span><span class="cd-sub-r">'+fmtMoney(cart.total_price,cur)+'</span></div>'+
      '<div class="cd-code"><span>Seasonal offer</span><strong>Use SUM25 for 25% off at checkout.</strong></div>'+
      '<ul class="cd-trust"><li>Selected size saved in your cart</li><li>Discreet packaging</li><li>Secure Shopify checkout</li></ul>'+
      '<a href="'+CHECKOUT_URL+'" class="btn btn-lg cd-checkout">Checkout</a>'+
      '<p class="cd-note">Taxes &amp; shipping calculated at checkout</p>';
  }
  function refreshCart(){
    return fetch(CART_URL,{headers:{Accept:'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){updateBadges(cart.item_count);renderDrawer(cart);return cart;})
      .catch(function(){});
  }
  async function addToCart(form, directCheckout, submitter){
    var fd=new FormData(form);
    var btn=submitter||form.querySelector('button[type=submit]');
    var giftMarker=form.querySelector('[data-free-gift-id]');
    var giftId=form.getAttribute('data-free-gift-id')||(giftMarker&&giftMarker.value);
    var orig=btn?btn.textContent:null;
    if(btn){btn.disabled=true;btn.textContent=directCheckout?'Preparing checkout…':'Adding…';}
    try{
      var res;
      if(giftId){
        var selectedId=fd.get('id');
        var qty=Math.max(1,parseInt(fd.get('quantity'),10)||1);
        if(!selectedId) throw new Error('Please choose a size first.');
        res=await fetch(ADD_URL,{
          method:'POST',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[
            {id:String(selectedId),quantity:qty},
            {id:String(giftId),quantity:qty,properties:{_promo:'Free with Corset Mona'}}
          ]})
        });
      }else{
        res=await fetch(ADD_URL,{method:'POST',body:fd,headers:{Accept:'application/json'}});
      }
      if(!res.ok){var e=await res.json().catch(function(){return{};});throw new Error(e.description||e.message||'Add failed');}
      await refreshCart();
      setSizeOpen(false);
      if(directCheckout){window.location.href=CHECKOUT_URL;return;}
      setOpen(true);
    }catch(err){
      alert(err.message||'Unable to add to cart');
    }finally{
      if(btn){btn.disabled=false;btn.textContent=orig||'Add to cart';}
    }
  }
  // interept cart icon clicks → open drawer
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-size-open]')){e.preventDefault();setSizeOpen(true);return;}
    if(e.target.closest('[data-size-close]')){e.preventDefault();setSizeOpen(false);return;}
    var checkout=e.target.closest('.cd-checkout,.cp-checkout');
    if(checkout&&cartBusy){e.preventDefault();return;}
    var toggle=e.target.closest('a[href="/cart"],[data-cart-toggle]');
    if(toggle){e.preventDefault();setOpen(true);refreshCart();return;}
    if(e.target.closest('[data-cart-close]')){setOpen(false);return;}
    var qty=e.target.closest('[data-cart-qty]');
    if(qty){
      var key=qty.getAttribute('data-cart-qty');
      var delta=parseInt(qty.getAttribute('data-delta'),10)||0;
      var row=qty.closest('[data-key]');
      var cur=row?parseInt(row.querySelector('.cd-qty-v,.cp-qty-v').textContent,10)||0:0;
      var next=Math.max(0,cur+delta);
      setCartBusy(true);
      fetch(CHANGE_URL,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:next})})
        .then(function(){return refreshCart();})
        .then(function(){if(window.location.pathname.indexOf('/cart')===0){window.location.reload();return;}})
        .catch(function(){})
        .finally(function(){if(window.location.pathname.indexOf('/cart')!==0) setCartBusy(false);});
      return;
    }
    var rm=e.target.closest('[data-cart-remove]');
    if(rm){
      var k=rm.getAttribute('data-cart-remove');
      setCartBusy(true);
      fetch(CHANGE_URL,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:k,quantity:0})})
        .then(function(){return refreshCart();})
        .then(function(){if(window.location.pathname.indexOf('/cart')===0){window.location.reload();return;}})
        .catch(function(){})
        .finally(function(){if(window.location.pathname.indexOf('/cart')!==0) setCartBusy(false);});
    }
  });
  // pdp qty buttons
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-qty-delta]');
    if(!b) return;
    var input=b.parentElement.querySelector('input[name="quantity"]');
    if(!input) return;
    var d=parseInt(b.getAttribute('data-qty-delta'),10)||0;
    input.value=Math.max(1,(parseInt(input.value,10)||1)+d);
  });
  // variant picker — match selected option combo to a variant
  document.addEventListener('change',function(e){
    var opt=e.target.closest('[data-pdp-option]');
    if(!opt) return;
    var form=opt.closest('form');
    if(!form) return;
    syncPdpVariant(form);
  });
  // intercept add-to-cart submit
  document.addEventListener('submit',function(e){
    var form=e.target.closest('form[action="/cart/add"],form[data-cart-form]');
    if(!form) return;
    if(form.classList.contains('pdp-form')&&!syncPdpVariant(form)){
      var first=form.querySelector('[data-pdp-option]');
      if(first) first.focus();
      e.preventDefault();
      return;
    }
    e.preventDefault();
    var submitter=e.submitter||document.activeElement;
    var direct=!!(submitter&&submitter.closest&&submitter.closest('[data-checkout-now]'));
    addToCart(form,direct,submitter&&submitter.tagName==='BUTTON'?submitter:null);
  });
  // keyboard: esc closes drawer
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){setSizeOpen(false);setOpen(false);}
  });
  // on load: populate badges + prefill drawer
  applyPriceTest();
  refreshCart();
  document.querySelectorAll('.pdp-form').forEach(function(form){syncPdpVariant(form);});

  // The homepage A la carte block was removed by request. Keep this legacy
  // fallback disabled so cached product JSON cannot recreate it after load.
  function injectAlacarteFallback(){
    return;
    if(document.querySelector('.alacarte-shop')) return;
    var target=document.querySelector('.ornament .ornament-word');
    target=target&&target.closest('.ornament');
    if(!target) return;
    Promise.all([
      fetch('/products/noir-prive-pheromones.js',{headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;}),
      fetch('/products/corset-mona-red.js',{headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;}),
      fetch('/products/corset-mona-black.js',{headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;}),
      fetch('/products/mona-underwear-red.js',{headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;}),
      fetch('/products/mona-underwear-black.js',{headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;})
    ]).then(function(products){
      var perfume=products[0],red=products[1],black=products[2],underwearRed=products[3],underwearBlack=products[4];
      if(!perfume&&!red&&!black&&!underwearRed&&!underwearBlack) return;
      var giftVariant=perfume&&perfume.variants&&perfume.variants.length?perfume.variants[0].id:null;
      function card(p,meta){
        if(!p) return '';
        var img=p.featured_image||((p.images&&p.images.length)?p.images[0]:null);
        var form='';
        if(meta.size){
          var opts=(p.variants||[]).map(function(v){
            return '<option value="'+escapeHtml(v.id)+'"'+(v.available?'':' disabled')+'>'+escapeHtml(v.title)+(v.available?'':' - Sold out')+'</option>';
          }).join('');
          form='<form action="/cart/add" method="post" class="alacarte-card-form" data-cart-form'+(meta.gift&&giftVariant?' data-free-gift-id="'+escapeHtml(giftVariant)+'"':'')+'>'+
            '<label class="alacarte-size-label" for="'+escapeHtml(meta.id)+'-fallback">Choose size</label>'+
            '<select id="'+escapeHtml(meta.id)+'-fallback" name="id" class="alacarte-size-select" required>'+
              '<option value="" selected disabled>Select size</option>'+opts+
            '</select>'+
            '<input type="hidden" name="quantity" value="1">'+
            '<button type="submit" name="add" class="btn btn-lg">'+escapeHtml(meta.button||'Add to cart')+'</button>'+
          '</form>';
        }else{
          var v=(p.variants||[]).filter(function(x){return x.available;})[0]||(p.variants||[])[0];
          if(v){
            form='<form action="/cart/add" method="post" class="alacarte-card-form" data-cart-form>'+
              '<input type="hidden" name="id" value="'+escapeHtml(v.id)+'">'+
              '<input type="hidden" name="quantity" value="1">'+
              '<button type="submit" name="add" class="btn btn-lg">Add perfume to cart</button>'+
            '</form>';
          }
        }
        return '<article class="alacarte-card '+(meta.perfume?'alacarte-card--perfume':'')+'">'+
          '<a href="/products/'+escapeHtml(p.handle)+'" class="alacarte-img">'+(img?'<img src="'+escapeHtml(img)+'" alt="'+escapeHtml(p.title)+'" loading="lazy">':'')+'</a>'+
          '<div class="alacarte-info">'+
            '<span class="alacarte-kicker">'+escapeHtml(meta.kicker)+'</span>'+
            '<a href="/products/'+escapeHtml(p.handle)+'" class="alacarte-title">'+escapeHtml(meta.title||p.title)+'</a>'+
            '<p class="alacarte-desc">'+escapeHtml(meta.desc)+'</p>'+
            (meta.desc2?'<p class="alacarte-desc">'+escapeHtml(meta.desc2)+'</p>':'')+
            (meta.gift&&giftVariant?'<p class="alacarte-promo">Promotion: includes Noir Privé Pheromones free.</p>':'')+
            '<span class="alacarte-price">'+escapeHtml(meta.price)+'</span>'+
            form+
          '</div>'+
        '</article>';
      }
      var section=document.createElement('section');
      section.id='np-alacarte';
      section.className='alacarte-shop reveal in';
      section.innerHTML=
        '<div class="alacarte-head">'+
          '<span class="label-quiet">A la carte</span>'+
          '<span class="alacarte-script">One more element</span>'+
          '<span class="alacarte-serif">Complete the night</span>'+
          '<p class="alacarte-lede">Add a single piece to your order, or let it stand alone. Corset Mona receives Noir Privé Pheromones free; Mona Underwear brings Chantilly lace to the smallest detail.</p>'+
        '</div>'+
        '<div class="alacarte-grid">'+
          card(perfume,{perfume:true,kicker:'Pheromone scent',title:'Noir Privé Pheromones',desc:'This isn’t about becoming someone else’s fantasy — it’s about turning the volume up on your own sexuality.',desc2:'A pheromone-infused scent moves with your body like a second skin, making you feel more magnetic, more sensual, and more in command of the energy you already carry.',price:'$72.00'})+
          card(red,{size:true,gift:true,id:'corset-red-size',kicker:'Red Chantilly lace',desc:'Made of French Chantilly lace with structured boning, garter details, and a sculpted strapless fit.',price:'$370.99',button:'Add corset to cart'})+
          card(black,{size:true,gift:true,id:'corset-black-size',kicker:'Black Chantilly lace',desc:'Made of French Chantilly lace with structured boning, garter details, and a sculpted strapless fit.',price:'$370.99',button:'Add corset to cart'})+
          card(underwearRed,{size:true,id:'mona-underwear-red-size',kicker:'Red Chantilly lace',desc:'Cut in sheer French Chantilly lace with adjustable side straps and polished gold-tone hardware. A deliberate little provocation, finished with the Maison\'s quiet restraint.',price:'$98.99',button:'Add underwear to cart'})+
          card(underwearBlack,{size:true,id:'mona-underwear-black-size',kicker:'Black Chantilly lace',desc:'Sheer French Chantilly lace, fine eyelash edges, and adjustable side straps in Noir Privé black. Quiet from a distance; impossible to forget up close.',price:'$98.99',button:'Add underwear to cart'})+
        '</div>';
      document.querySelectorAll('.split-perfume,.corset-shop').forEach(function(el){el.style.display='none';});
      target.parentNode.insertBefore(section,target);
    });
  }
  if(document.readyState!=='loading') injectAlacarteFallback();
  else document.addEventListener('DOMContentLoaded',injectAlacarteFallback);

  // ============ AGE GATE ============
  var AG_KEY='np_ag_confirmed_v1';
  function ageShow(){
    var el=document.getElementById('ageGate');
    if(!el) return;
    el.classList.add('open');
    el.setAttribute('aria-hidden','false');
    document.body.classList.add('ag-open');
  }
  function ageHide(){
    var el=document.getElementById('ageGate');
    if(!el) return;
    el.classList.remove('open');
    el.setAttribute('aria-hidden','true');
    document.body.classList.remove('ag-open');
  }
  function ageInit(){
    try{if(localStorage.getItem(AG_KEY)==='1') return;}catch(e){}
    ageShow();
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-ag-confirm]')){
      try{localStorage.setItem(AG_KEY,'1');}catch(e){}
      ageHide();
    }
  });
  if(document.readyState!=='loading') ageInit();
  else document.addEventListener('DOMContentLoaded',ageInit);

  // ============ SIZE GUIDE ============
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-sg-open]')){
      var sg=document.getElementById('sizeGuide');
      if(sg){sg.classList.add('open');sg.setAttribute('aria-hidden','false');}
    }
    if(e.target.closest('[data-sg-close]')){
      var sg=document.getElementById('sizeGuide');
      if(sg){sg.classList.remove('open');sg.setAttribute('aria-hidden','true');}
    }
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      var sg=document.getElementById('sizeGuide');
      if(sg&&sg.classList.contains('open')){sg.classList.remove('open');sg.setAttribute('aria-hidden','true');}
    }
  });
})();
